export enum LDFlags {
  DD_SIGNING_USER = 'dd-signing-user',
  AUTO_ASSIGNING_DEALS = 'auto-assigning-deals',
  MULTIPLE_CREDIT_APPS = 'multiple-credit-apps',
  PREQUAL_AUTOSTRUCTURE = 'prequal-smart-autostructure',
  IGNORE_TT_VEHICLE_MILEAGE_ERROR = 'ignore-tt-vehicle-mileage-error',
  BREAK_OUT_CREDIT_AND_DEBIT_CARDS = 'break-out-credit-and-debit-cards',
  SUGGESTED_MESSAGE_BUTTON = 'dd-suggested-message-button',
  STATE_DOC_FEE = 'state_doc_fee_test',
  SECURE_INFO_LINK = 'secure-info-link',
  EMBEDDED_INSURANCE = 'embedded-insurance',
  ADD_TATER_TITLE_PROCESSOR = 'add-tater-title-processoor',
  DD_CANADA_DEALS = 'dd-canada-deals',
  FIRST_FEDERAL_PAYOFFS = 'first-federal-payoffs',
}

export type FlagOverrides = {
  [key in LDFlags]?: unknown;
};
